import validator from "validator";
import { IInputForm } from '../../interfaces/IInputForm';
import { IInputFormSharePoint } from '../../interfaces/IInputFormSharePoint';
import { IInputValidation } from '../../interfaces/IInputValidation';

export class CustomInputService {

  public static validInput(inputForm: IInputFormSharePoint, value: any, inputFormList?: IInputFormSharePoint[], fileExist?: boolean, fileName?: string, fileContent?: any): IInputFormSharePoint {

        if (inputForm.Type === "TaxonomyFieldType" && inputForm.InputValidation.IsRequiredMessage != null) {
            if (!inputForm.IsValid) {
                inputForm.IsValid = false;
                inputForm.Message = inputForm.InputValidation.IsRequiredMessage;
            }
            return inputForm;
        }
        else {
            inputForm.Value = value;
            inputForm.IsValid = true;
            inputForm.IsEmptyAndNotRequired = false;

            value = inputForm.Type === "DateTime" && value != null ? value.toString() : value
        }        

        if (!inputForm.IsVisible) {
            return inputForm;
        }    

        if (!fileExist && inputForm.InputValidation.IsRequired && inputForm.InputValidation.IsRequiredMessage != null ) {
            if (value == null || validator.isEmpty(value, { ignore_whitespace: true })) {
                inputForm.IsValid = false;
                inputForm.Message = inputForm.InputValidation.IsRequiredMessage;
                return inputForm;
            }

            if (inputForm.Type === "Choice") {
                if(inputForm.Choices != null && inputForm.Choices.split(';').indexOf(value) === -1) {
                    inputForm.IsValid = false;
                    inputForm.Message = inputForm.InputValidation.IsRequiredMessage;
                    return inputForm;
                }
            }            
        }

        if (!fileExist && !inputForm.InputValidation.IsRequired) {
            if (value == null || validator.isEmpty(value, { ignore_whitespace:true })) {
                inputForm.IsEmptyAndNotRequired = true;
            }
        }

        if (inputForm.InputValidation.IsEmail && inputForm.InputValidation.IsEmailMessage != null) {
            if (!validator.isEmail(value)) {
                inputForm.IsValid = false;
                inputForm.Message = inputForm.InputValidation.IsEmailMessage;
                return inputForm;
            }
        }

        if (inputForm.InputValidation.IsTelNumber && inputForm.InputValidation.IsTelNumberMessage != null) {
            const regexp = new RegExp("^[0-9]{10,10}$");
            if (value != null && !validator.isEmpty(value) && !regexp.test(value)) {
                inputForm.IsValid = false;
                inputForm.Message = inputForm.InputValidation.IsTelNumberMessage;
                return inputForm;
            }
        }

        if (inputFormList != null && inputForm.InputValidation.IsEqualsToInput !== ''
            && inputForm.InputValidation.IsEqualsToInput != null && inputForm.InputValidation.IsEqualsToInputMessage != null) {
            if (!validator.equals(value, inputFormList[inputForm.InputValidation.IsEqualsToInput].Value)) {
                inputForm.IsValid = false;
                inputForm.Message = inputForm.InputValidation.IsEqualsToInputMessage;
                return inputForm;
            }
        }

        if (inputForm.InputValidation.IsRegexMatch !== '' && inputForm.InputValidation.IsRegexMatch != null && inputForm.InputValidation.IsRegexMatchMessage != null) {
            const regexp = new RegExp(inputForm.InputValidation.IsRegexMatch);
            if (value != null && !validator.isEmpty(value) && !regexp.test(value)) {
                inputForm.IsValid = false;
                inputForm.Message = inputForm.InputValidation.IsRegexMatchMessage;
            }
        }

        if (inputForm.InputValidation.IsNotEqualsToValue !== '' && inputForm.InputValidation.IsNotEqualsToValue != null
            && inputForm.InputValidation.IsNotEqualsToValueMessage != null) {
            if (validator.equals(value, inputForm.InputValidation.IsNotEqualsToValue)) {
                inputForm.IsValid = false;
                inputForm.Message = inputForm.InputValidation.IsNotEqualsToValueMessage;
                return inputForm;
            }
        }

        if (inputForm.InputValidation.IsMaxSizeMo != null && inputForm.InputValidation.IsMaxSizeMoMessage != null) {
            if (value / 1024 / 1024 > inputForm.InputValidation.IsMaxSizeMo) {
                inputForm.IsValid = false;
                inputForm.Message = inputForm.InputValidation.IsMaxSizeMoMessage;
                return inputForm;
            }
        }

        if (inputForm.InputValidation.IsExtensions != null && inputForm.InputValidation.IsExtensionsMessage != null
            && fileName != null && fileName !== "") {

            let fileExtension = fileName.split('').reverse().join('').split(/\.(.+)/)[0];
            fileExtension = fileExtension.split('').reverse().join('');
            let isValid = false;
            inputForm.InputValidation.IsExtensions.map(ext => {
                if (ext.toLowerCase() === fileExtension.toLowerCase()) {
                    isValid = true;
                    return;
                }
            });

            if (!isValid) {
                inputForm.IsValid = false;
                inputForm.Message = inputForm.InputValidation.IsExtensionsMessage;
                return inputForm;
            }
        }

        if (inputForm.InputValidation.IsDimensionsWidth != null && inputForm.InputValidation.IsDimensionsHeight != null
            && inputForm.InputValidation.IsDimensionsMessage != null && fileContent != null) {
            const img = new Image();
            img.onload = function () {
                if (inputForm != null
                    && inputForm.Message != null
                    && inputForm.InputValidation != null
                    && inputForm.InputValidation.IsDimensionsWidth != null
                    && inputForm.InputValidation.IsDimensionsHeight != null
                    && inputForm.InputValidation.IsDimensionsMessage != null) {

                    if (this['width'] < inputForm.InputValidation.IsDimensionsWidth || this['height'] < inputForm.InputValidation.IsDimensionsHeight) {

                        inputForm.IsValid = false;
                        inputForm.Message = inputForm.InputValidation.IsDimensionsMessage;
                        return inputForm;
                    }
                }
            };
            img.src = URL.createObjectURL(fileContent);
        }

        return inputForm;
    }

    public static inputValidationInit(): IInputValidation {
        return {
            IsRequired: false,
            IsRequiredMessage: '',
            IsEmail: false,
            IsEmailMessage: '',
            IsEqualsToInput: '',
            IsEqualsToInputMessage: '',
            IsRegexMatch: '',
            IsRegexMatchMessage: '',
        }
    }

    public static inputFormInit(inputValidationInit: IInputValidation): IInputForm {
        return {
            Value: '',
            IsValid: true,
            ToUpper: false,
            ToUpperFirstLetter: false,
            Message: '',
            InputValidation: inputValidationInit,
            Name: '',
            PlaceHolder: '',
            Type: 'text',
            Label: '',
            DisabledAutoComplet: false,
            DisabledPaste: false,
            IsReadOnly: false,
            IsVisible: true,
        }
    }

    public static inputFormSharePointInit(inputValidationInit: IInputValidation): IInputFormSharePoint {
        return {
            Value: '',
            IsValid: true,
            Message: '',
            ToUpper: false,
            ToUpperFirstLetter: false,
            InputValidation: inputValidationInit,
            Name: '',
            PlaceHolder: '',
            Type: 'text',
            Label: '',
            DisabledAutoComplet: false,
            DisabledPaste: false,
            InternalName: '',
            Choices: '',
            Description: '',
            IsReadOnly: false,
            IsVisible: true,
            SendToSharePoint: false,
            Terms: []
        }
    }
}
